<template>
	<div
		class="xs-12 cu2 node"
		:style="`padding-left: ${depth === 0 ? depth : depth + 10}px`"
		@click.stop="$emit('node:click', node)"
	>
		<div
			class="flex wrap xs-middle pl1 pr1 lh125 fs4 label"
			:class="{ 'bg7--l3': node.isSelected }"
		>
			<div class="flex xs-middle xs-12 md-6">
				<!-- Expand icon -->
				<crm-icon
					v-if="hasChildren"
					name="chevron-right"
					class="arrow"
					:class="{ 'arrow-rotated': node.isExpanded }"
				/>

				<!-- No children icon -->
				<crm-icon v-if="!hasChildren" name="circle" />

				<!-- Icon -->
				<crm-icon v-if="node.icon" :name="node.icon" class="mr1" />

				<!-- Label -->
				{{ node.label }}
				{{ node.name }}
			</div>

			<!-- Actions -->
			<div
				class="flex xs-left md-right xs-12 md-6 mt1 mb1 md-mt0 md-mb0"
				v-if="node.isSelected"
			>
				<j-button
					v-if="options.hasAddChildAction"
					type="secondary"
					size="xsmall"
					class="mr1"
					@click.native.stop="$emit('node:addChild', node)"
				>
					<crm-icon name="add" size="small" color="c5" />
					{{ options.addChildActionLabel }}
				</j-button>
				<j-button
					v-if="options.hasUpdateAction"
					type="secondary"
					size="xsmall"
					class="mr1"
					@click.native.stop="$emit('node:update', node)"
				>
					<crm-icon name="edit" size="small" color="c5" />
					{{ options.updateActionLabel }}
				</j-button>
				<j-button
					v-if="options.hasMoveAction"
					type="secondary"
					size="xsmall"
					class="mr1"
					@click.native.stop="$emit('node:move', node)"
					>{{ options.moveActionLabel }}</j-button
				>
				<j-button
					v-if="options.hasDeleteAction"
					type="error"
					size="xsmall"
					@click.native.stop="$emit('node:delete', node)"
					><span class="c5">{{ options.deleteActionLabel }}</span></j-button
				>
			</div>
		</div>

		<div v-if="hasChildren && node.isExpanded" class="fadein">
			<tree-node
				v-for="child in node.children"
				:node="child"
				:key="child.id"
				:depth="depth + 1"
				:options="options"
				@node:click="$emit('node:click', $event)"
				@node:update="$emit('node:update', $event)"
				@node:addChild="$emit('node:addChild', $event)"
				@node:move="$emit('node:move', $event)"
				@node:delete="$emit('node:delete', $event)"
			/>
		</div>
	</div>
</template>

<script>
import "@/assets/css/tokens.css"
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton"

export default {
	name: "tree-node",
	components: { CrmIcon, JButton },
	props: {
		node: {
			type: Object,
			default: () => {}
		},
		options: {
			type: [Object, null],
			required: false
		},
		depth: {
			type: Number,
			default: 0
		}
	},
	computed: {
		hasChildren() {
			return this.node.children && this.node.children.length > 0 ? true : false
		}
	},
	methods: {}
}
</script>

<style scoped>
.label {
	min-height: 40px;
	border: 1px solid var(--color7);
	margin-top: -1px; /* Preventing double border on the top edge of the box */
}

.label:hover {
	background-color: var(--color7-light-3);
}

.arrow {
	transition: all 120ms ease-in;
}

.arrow-rotated {
	transform: rotate(90deg);
}

.arrow-invisible {
	visibility: hidden;
}

.fadein {
	animation: fadein 280ms ease-in-out;
}
</style>
